import { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios'
import {
  ItemsResponse,
  ListResponse,
  MessageAction,
  NotificationParams,
} from '/@src/models/api'
import { OmniNotificationFormParams } from '/@src/components/pages/forms/content/NotificationForm.vue'

export function postNotification(
  api: AxiosInstance,
  params: NotificationParams
): AxiosPromise {
  return api.post('/v1/admin/push/umeng/broadcast', params)
}

export function postOmniNotificationKv(
  api: AxiosInstance,
  params: OmniNotificationFormParams
): AxiosPromise {
  return api.post('/v1/admin/kv/omni-notification', params)
}
